import { Linking } from "react-native"

interface ShareProps {
  message: string
  url?: string
  title: string
  subject?: string
}

export const useShare = () => {
  return async ({ message, url, title, subject }: ShareProps) => {
    await Linking.openURL(
      `mailto:?subject=${subject || title}&body=${message} ${url || ""}`
    )
  }
}
